import React, { useEffect, useRef, useState } from 'react';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import axios from 'axios';
const JWT = ({
    noPermissionRoute = '',
    exceptionPathData = [

    ],
    loginPath = "/login"
}) => {
    const navigate = useNavigate();
    const needReload = useRef(false)
    axios.interceptors.request.use(
        async (config) => {
            const access_token = localStorage.getItem("access_token");

            if (access_token) {
                config.headers = {
                    ...config.headers,
                    authorization: `Bearer ${access_token}`,
                };
            }

            return config;
        },
        (error) => Promise.reject(error)
    );

    axios.interceptors.response.use(
        response => {
            return response
        },
        function (error) {
            const access_token_url = '/access_token';
            const config = error.config
            if (
                error.response?.status === 401 &&
                config.url === access_token_url
            ) {
                window.location.href = (loginPath)
                return Promise.reject(error)
            }

            if (error.response?.status === 401 && !config._retry) {
                config._retry = true
                const refreshToken = localStorage.getItem('refresh_token')
                if (!refreshToken) window.location.href = (loginPath)
                return axios
                    .post(access_token_url, {
                        refresh_token: refreshToken
                    })
                    .then(res => {
                        if (res?.status === 201) {
                            localStorage.setItem('access_token', res.data.access_token);
                            config.headers = {
                                ...config.headers,
                                authorization: `Bearer ${localStorage.getItem('access_token')}`,
                            };
                            return axios(config)
                        }
                    })
            }
            return Promise.reject(error)
        }
    )
    const location = useLocation()
    const [userPermissionData, setUserPermissionData] = useState(null)
    const getStaffDiverge = () => {
        axios
            .get('/organization_structure/api/staff_diverge_self', {

            })
            .then((response) => {
                let data = response.data?.data || []
                let first_data = data.find(ele => true)
                setUserPermissionData(first_data?.user_permission_data)
            })
            .finally(() => {
            })
    }
    const HasPermission = ({ locationPathname, permissions }) => {
        let hasPermission = permissions.find((element) => { return element?.permission_url === locationPathname })
        if (!hasPermission && !exceptionPathData.includes(locationPathname)) {
            // navigate(noPermissionRoute)
        }
    }
    useEffect(() => {
        getStaffDiverge()
    }, [])
    useEffect(() => {
        if (!!userPermissionData) {
            HasPermission({ locationPathname: location?.pathname, permissions: userPermissionData })
        }
    }, [userPermissionData])
    useEffect(() => {
        //特別撰寫導向
        if (location?.pathname === "/library/backstage/depth" && location?.search === "") {
            navigate('/library/backstage/depth?department_depth_id=209&department_id=513')
        }
        if (!!userPermissionData) {
            HasPermission({ locationPathname: location?.pathname, permissions: userPermissionData })
        }
        if (needReload.current === true) {
            getStaffDiverge()
        }
        if (location?.pathname === "/book/PermissionList") {
            needReload.current = true
        }
        else {
            needReload.current = false
        }

    }, [location])

    return <Outlet />
}
export default JWT